import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, initOutboundLinkTracking } from "@/lib/analytics";

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const cleanup = initOutboundLinkTracking();
    return cleanup;
  }, []);
};
